export default __webpack_public_path__ + "images/lever_logotype-3a4830492b143717fbf7dbd20c06a0f9.svg";